import { DOCUMENT, isPlatformBrowser } from '@angular/common'
import { Component, HostListener, Inject, PLATFORM_ID, OnDestroy, Input, OnChanges, SimpleChanges, Output, EventEmitter, AfterViewInit, ElementRef, Renderer2, DoCheck } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { delay, filter, of, takeWhile } from 'rxjs';
import { MenuList } from '../shared/data';
@Component({
  selector: 'app-global-navigation',
  templateUrl: './global-navigation.component.html'
})
export class GlobalNavigationWithThemeComponent implements OnDestroy, OnChanges, DoCheck, AfterViewInit {
  @Input() showMenu = false;
  @Output() cascadeOpened = new EventEmitter();
  @Output() cascadeThemeOpened = new EventEmitter();
  isShowMenubar = false;
  currentMenu: any;
  currentMenuIndex: any;
  isShowCascadebar = false;
  breadCrumbLimit: number = 20;
  public breadcrumbsName: any[] = [];
  menuList = MenuList;
  cascadeMenus: any[] = [];
  isLinksClickable: boolean = false;
  nextIconClass: string = 'icon-chevron-slash';
  numberOfLinksVisible = 3;
  breadcrumbsContainer: string = 'breadcrumbsContainer';
  title = 'Welcome';
  subTitle = 'Overline';
  backUrl = './';
  logoUrl = '/';
  logo = '../../assets/images/logo-mee-black-mac.svg';
  smallLogo = '../../assets/images/logo.svg';
  logoAltText = 'Macmillan Education Everywhere Platform';
  moreMenuTitle = 'More';
  ariaLabels: any = {
    backButtonAriaLabel: "Back",
    closeButtonAriaLabel: "Close",
    hamburgerAriaLabel: "Menu",
    logoIcon: "Logo"
  };
  activeHamburger = false as boolean;
  currentUrl = '' as string;
  buttonType = 'button' as string;
  buttonId = 'hamburgerIcon' as string;
  buttonValue = 'hamburger' as string;

  dummyId6: string = 'dummyId6';
  dummyId7: string = 'dummyId7';
  list = [
    { key: "Start Date", value: "21/05/20" },
    { key: "End Date", value: "22/06/20" },
  ];
  subActive = true;
  showTitle = false;
  showOverlay: boolean = false;
  isJS: boolean;
  cascadeMenubarLabel: string = '';
  activeMenuHierarchy: any;
  focusableElements: Array<HTMLElement> = [];
  isCascadeThemeOpens = false as boolean;
  themeMenu = { id: 'fantasyBlue', class: 'fantasy-blue', hierarchyLevel: '4_3', name: 'Fantasy Blue', hasTheme: true, url: 'sub1', queryParams: { themeId: 'fantasy-blue' } };
  hasThemeOption = true as boolean;
  hasBackButton = true as boolean;
  optInStatusIcon= 'icon-check' as string;
  isThemeMenubarExpand = false as boolean;
  WindowMaxWidth = 1024;
  constructor(private activRoute: ActivatedRoute, private router: Router,
    private elementRef: ElementRef,
    @Inject(PLATFORM_ID) public platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2) {
    if (!isPlatformBrowser(platformId)) {
      this.isShowMenubar = true;
      this.isJS = false;
    } else {
      this.isJS = true;
      const windowWidth = window?.innerWidth;
      if ((windowWidth >= this.WindowMaxWidth)) {
        this.isShowMenubar = true;
      } else {
        this.showTitle = true;
        this.isShowMenubar = false;
      }
    }
    this.prepareNoJsParamsInCascade(this.menuList);
    this.setActiveAndSelected();
    this.cascadeMenubarLabel = (!isPlatformBrowser(this.platformId) || this.isMobileWidth()) ? 'Back' : 'Menu';
    this.router.events.pipe(takeWhile(() => this.subActive)).pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
      this.showOverlay = false;
      this.showTitle = true;
      if (!this.isMobileWidth()) {
        this.cascadeMenus = [];
      }
      let param = this.activRoute.snapshot.queryParams;
      const htmlElement = document.querySelector('html');
      if (htmlElement) {
        if (this.activRoute.snapshot.queryParams.themeId) {
          htmlElement.setAttribute('data-theme', this.activRoute.snapshot.queryParams.themeId);
        } else if (this.hasThemeOption) {
          htmlElement.setAttribute('data-theme', this.themeMenu.class);

        }
      }
      this.activeMenuHierarchy = param?.activeMenuHierarchy;
      this.currentUrl = this.router.url.split('?')[0];
      let hierarchyLevel = param?.menuHierarchy?.split('_') || [];
      if (param?.menuHierarchy) {
        if (param?.hasTheme) {
          this.isCascadeThemeOpens = true;
        } else {
          this.isCascadeThemeOpens = false;
        }
        if (!this.isMobileWidth()) {
          this.getMenuItemAndShowNavigation(hierarchyLevel);
        }
        if (!isPlatformBrowser(this.platformId)) {
          this.isShowCascadebar = true;
          this.isShowMenubar = false;
          this.cascadeOpened.emit(true);
        }
        if (this.isMobileWidth()) {
          this.isShowCascadebar = false;
        }
      } else {
        if (this.isMobileWidth()) {
          this.isShowMenubar = false
        }
        if (!isPlatformBrowser(this.platformId) && param?.activeMenuHierarchy) {
          this.showOverlay = true;
        }
      }
      this.setActiveAndSelected();
      this.prepareNoJsParamsInCascade(this.menuList);
    })
  }
  
  ngAfterViewInit(): void {
    this.elementRef.nativeElement.addEventListener('keydown', ($event: any) => { this.handleKeyDown($event) }, true);
  }

  getMenuItemAndShowNavigation(hierarchyLevel: any) {
    this.cascadeMenus = [];
    this.showTitle = true;
    if (hierarchyLevel?.length > 0 && hierarchyLevel[0] > -1) {
      let item = this.getMenuItem(this.menuList, hierarchyLevel);
      if (item) {
        this.cascadeMenus.push({
          name: !this.isCascadeThemeOpens ? (!isPlatformBrowser(this.platformId) || this.isMobileWidth()) ? 'Back' : 'Menu' : '',
          isVisible: true,
          menus: item
        });
        this.showOverlay = (!isPlatformBrowser(this.platformId)) ? true : false;
        this.isShowCascadebar = true;
        this.isShowMenubar = false;
        this.cascadeOpened.emit(true);
      }
    } else {
      this.showOverlay = false;
      this.isShowCascadebar = false;
      this.isShowMenubar = true;
      this.cascadeOpened.emit(false);
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (!isPlatformBrowser(this.platformId)) {
      this.isShowMenubar = true;
      this.isJS = false;
    } else {
      this.isJS = true;
      const windowWidth = window?.innerWidth;
      this.isShowMenubar = true;
      if ((windowWidth >= 1024)) {
        if (this.isCascadeThemeOpens) {
          this.cascadeThemeOpened.emit(false);
        }
      } else {
        if (this.isCascadeThemeOpens) {
          this.cascadeThemeOpened.emit(true);
        }
        this.showTitle = false;
      }
      this.cascadeOpened.emit(true);
    }
  }
  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: any) {
    let value: any = document.querySelectorAll('[data-id]');
    if (value) {
      if (!this.isCascadeThemeOpens) {
        if (value.length >= 2) {
          const parentElement = value[value.length - 2].children[0];
          function focusOnSelectedClass(parentElement: { querySelector: (arg0: string) => any; }) {
            let selectedElement = parentElement.querySelector('.c-menu__list-item-link--is-selected');
            if (selectedElement) {
              selectedElement.focus();
            }
          }
          focusOnSelectedClass(parentElement);
        }
        if (value.length == 1) {
          let singleCascade = document.querySelectorAll('.c-menu__list-item-link--is-selected');
          if (singleCascade.length > 0) {
            (singleCascade[0] as HTMLElement).focus();
          }
        }
      }
      else if(this.isCascadeThemeOpens){
        let themeElemet = document.getElementById('themeMenuId');
        themeElemet?.focus();
        this.isCascadeThemeOpens = false;
        this.showOverlay = false;
      }
      else {
        value[0]?.focus();
        this.showOverlay = false;
      }
      if (this.isShowMenubar) {
        if (this.cascadeMenus.length === 0) {
          this.ovarlayClickJS();
        } else {
          this.cascadeMenus.splice(this.cascadeMenus.length - 1, 1);
        }
      }
    }
  }

  handleKeyDown(event: KeyboardEvent) {
    if (this.elementRef && this.elementRef.nativeElement && this.showOverlay) {
      this.focusableElements = this.elementRef.nativeElement.querySelectorAll('app-global-navigation button, app-global-navigation [href]');
      if (this.focusableElements.length > 0) {
        const lastElement = this.focusableElements[this.focusableElements.length - 1];
        const currentElement = event.target;
        if (lastElement === currentElement) {
          if (event.shiftKey && event.key === 'Tab' && this.focusableElements[this.focusableElements.length - 2]) {
            this.focusableElements[this.focusableElements.length - 2].focus();
            event.preventDefault();
          } else if (event.key === 'Tab' && this.focusableElements[0]) {
            this.focusableElements[0].focus();
            event.preventDefault();
          }
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.showMenu) {
      let param = this.activRoute.snapshot.queryParams?.menuHierarchy?.split('_');
      if (changes.showMenu.currentValue && this.isMobileWidth()) {
        if (this.cascadeMenus.length > 0 && param) {
          this.isShowCascadebar = changes.showMenu.currentValue;
        } else if (!param || this.isMobileWidth()) {
          this.isShowMenubar = changes.showMenu.currentValue;
        }
      } else if (changes.showMenu.currentValue === false && this.isMobileWidth()) {
        this.isShowMenubar = false;
        this.isShowCascadebar = false;
        this.menuList.forEach((obj: any, menuInx: number) => {
          if (obj.selected === true && !param) {
            obj.selected = false;
          }
        });
      }
    }
  }

  ngDoCheck(){
    if(this.isMobileWidth()){
      of('Observable To Update HTML').pipe(delay(0)).subscribe(() => {
      let cascadeMenusList = this.document.getElementsByClassName('c-navigation-cascading');
      if(cascadeMenusList.length !== 0){
        Array.from(cascadeMenusList).forEach((element, index) =>{
          if(index !== (cascadeMenusList.length -1)){
            (element as HTMLElement).setAttribute('style', 'display:none');
          } else{
            (element as HTMLElement).removeAttribute('style');
          }
        })
      }
    });
    }
    if(this.isCascadeThemeOpens){
      this.optInStatusIcon = 'icon-chevron-right';
      this.isThemeMenubarExpand = true;
    }else{
      this.optInStatusIcon = 'icon-check';
      this.isThemeMenubarExpand = false;
    }
  }

  prepareNoJsParamsInCascade(listItems: any) {
    if (listItems?.length > 0) {
      listItems.forEach((val: any, index: number) => {
        let param = this.activRoute.snapshot.queryParams;
        this.activRoute.snapshot.queryParams.themeId
        if ((param.themeId === val.class) && !val.isTitle && val.hasTheme && !val.isContainSubMenu && !this.isJS) {
          this.themeMenu = val;
          const hTMLElement = this.document.querySelector('html')
          if (hTMLElement) {
            this.renderer.setAttribute(hTMLElement, 'data-theme', param.themeId)
          }
          if(this.isCascadeThemeOpens){
            this.optInStatusIcon = 'icon-chevron-right';
            this.isThemeMenubarExpand = true;
          }else{
            this.optInStatusIcon = 'icon-check';
            this.isThemeMenubarExpand = false;
          }}
        this.appendUrlCheckSelected(val, index);
        if (val.children?.length > 0) {
          this.prepareNoJsParamsInCascade(val.children);
        }
      });
    }
  }

  appendUrlCheckSelected(val: any, index: number) {
    let urlChild = this.activRoute.snapshot.children;
    if (!isPlatformBrowser(this.platformId) && val.isContainSubMenu) {
      val.url = './' + urlChild[urlChild.length - 1]?.url[0]?.path;
      val.queryParams = { 'menuHierarchy': val.hierarchyLevel, activeMenuHierarchy: this.activeMenuHierarchy, hasTheme: val.hasTheme ? val.hasTheme : null, themeId: this.themeMenu? this.themeMenu.class: null };
    } else {
      if( urlChild[urlChild.length - 1]?.queryParams.themeId && !val.class){
        val.queryParams = {...val.queryParams, themeId:urlChild[urlChild.length - 1]?.queryParams.themeId }
      }
      val.queryParams = { ...val.queryParams, 'ver': Math.random().toString(36).substring(2, 5), activeMenuHierarchy: this.activeMenuHierarchy }
    }
  }

  getMenuItem(navItems: any, hierarchyLevel: any) {
    let item: any = {};
    if (hierarchyLevel[0] && navItems[hierarchyLevel[0]]?.children) {
      let childItems = navItems[hierarchyLevel[0]].children;
      hierarchyLevel.splice(0, 1);
      item = this.getMenuItem(childItems, hierarchyLevel);
    } else {
      item = navItems;
    }
    return item;
  }

  isMobileWidth() {
    if (isPlatformBrowser(this.platformId)) {
      return window?.innerWidth < 1023
    }
    else {
      return false;
    }
  }

  setActiveAndSelected(str?: string) {
    let param = this.activRoute.snapshot.queryParams;
    let urlHierarchyLevel = param?.menuHierarchy?.split('_') || [];
    let urlChild = this.activRoute.snapshot.children;
    this.menuList.forEach((obj: any, menuInx: number) => {
      if (obj.url && obj.url === urlChild[urlChild.length - 1]?.url[0].path) {
        obj.active = true;
        this.activeMenuHierarchy = obj?.queryParams?.menuHierarchy;
      }
      else {
        obj.active = false;
      }
      if (!isPlatformBrowser(this.platformId)) {
        let lastSelected = this.activRoute.snapshot.queryParams?.lastSelected;
        if (lastSelected && menuInx === parseInt(lastSelected) && this.activeMenuHierarchy) {
          obj.selected = true;
        } else {
          obj.selected = false;
        }
      } else if (urlHierarchyLevel && menuInx === parseInt(urlHierarchyLevel[0])) {
        obj.selected = true;
      } else if (this.cascadeMenus.length === 0) {
        obj.selected = false;
      }
    })
    if (this.cascadeMenus.length > 0) {
      this.cascadeMenus.forEach((menu: any, cascadeInx: number) => {
        menu?.menus?.forEach((obj: any, menuInx: number) => {
          if(!this.isJS){
            if((obj.class === param.themeId)&& urlChild[urlChild.length - 1]?.queryParams.themeId){
              obj.selected = true;
            }
            else{
              obj.selected = false;
            }
          }
          if (obj.url && obj.url === urlChild[urlChild.length - 1]?.url[0].path) {
            obj.active = true;
            this.activeMenuHierarchy = obj?.queryParams?.menuHierarchy;
            if (!isPlatformBrowser(this.platformId)) {
              this.showOverlay = false;
            }
          }
          else {
            obj.active = false;
          }
          if (cascadeInx > this.currentMenuIndex) {
            obj.active = false;
          } else if (cascadeInx === this.currentMenuIndex) {
            if (obj.id === this.currentMenu.id) {
              obj.active = true;
            }
            return obj;
          }
          if (!isPlatformBrowser(this.platformId) && this.activeMenuHierarchy) {
            let lastSelected = this.activRoute.snapshot.queryParams?.lastSelected;
            if (lastSelected && cascadeInx === 0 && menuInx === parseInt(lastSelected)) {
              obj.selected = true;
            } else if(!obj.hasTheme){
              obj.selected = false;
            }
          }
          else if (str === 'backClick' && urlHierarchyLevel[cascadeInx + 1] && menuInx === parseInt(urlHierarchyLevel[cascadeInx + 1])) {
            obj.selected = true;
          } else if (!this.cascadeMenus[cascadeInx + 1] && !urlHierarchyLevel[cascadeInx + 1] && !this.isCascadeThemeOpens) {
            obj.selected = false;
          }
        })
      })
    }
  }

  onCloseMenubar() {
    this.isShowMenubar = false;
    this.menuList.forEach((obj: any) => obj.active = false);
  }

  onClickMenu(menu: any) {
    this.cascadeMenus = [];
    this.breadcrumbsName = [];
    this.showTitle = false;
    if (isPlatformBrowser(this.platformId)) {
      this.isShowCascadebar = true;
    }
    if (menu.isContainSubMenu) {
      this.showOverlay = true;
      this.cascadeMenus.push({
        name: menu.name,
        isVisible: true,
        menus: menu.children
      });
      if (menu.hasTheme) {
        this.isCascadeThemeOpens = true;
        this.cascadeMenubarLabel = 'Theme Selection';
      } else {
        this.isCascadeThemeOpens = false;
        this.cascadeMenubarLabel = (!isPlatformBrowser(this.platformId) || this.isMobileWidth()) ? 'Back' : 'Menu';
      }
      const windowWidth = window?.innerWidth;
      if (windowWidth < 1023) {
        this.isShowMenubar = false
      }
      this.setActiveAndSelected();
      menu.selected = true;
    }
    else{
      this.isCascadeThemeOpens = false;
    }
    this.cascadeThemeOpened.emit(this.isCascadeThemeOpens);
  }

  onClickMoreMenu() {
    this.onClickCascadeClose();
  }

  onClickCascadeMenu(menu: any, index: number) {
    this.currentMenu = menu;
    this.currentMenuIndex = index;
    this.cascadeMenus.splice(index + 1, this.cascadeMenus.length - (index + 1));
    if (menu.isContainSubMenu) {
      this.showOverlay = true;
      this.displayBreadcrumbs(menu);
      this.cascadeMenus.push({
        name: menu.name,
        isVisible: true,
        menus: menu.children
      });
      this.cascadeMenus.forEach((val: any) => {
        val.menus.forEach((obj: any) => {
          if (obj.id === menu.id) {
            obj.selected = true;
          } else if (index === this.currentMenuIndex && !obj.isContainSubMenu) {
            obj.selected = false;
          }
        });
      });
    } else {
      if (this.isCascadeThemeOpens) {
        this.themeMenu = menu;
        const htmlElement = document.querySelector('html');
        if (htmlElement) {          
            this.renderer.setAttribute(htmlElement, 'data-theme', this.themeMenu.class);        
        }
        let themeElemet = document.getElementById('themeMenuId');
        themeElemet?.focus();
        if(window.innerWidth < this.WindowMaxWidth){
          of('Observable To Update HTML').pipe(delay(100)).subscribe(() => {
          let haburgerButton = document.getElementById('hamburgerIcon');
          haburgerButton?.focus();
          });
        }
        this.isShowMenubar = true;
        this.isCascadeThemeOpens = false;
        this.cascadeThemeOpened.emit(false);
      }
      this.cascadeMenus.forEach((val: any, index) => {
        val.menus.forEach((obj: any) => {
          if (obj.id === menu.id) {
            obj.selected = true;
          } else if (index === this.currentMenuIndex && obj.id !== menu.id) {
            obj.selected = false;
          }
        });
      });
      this.isShowCascadebar = false;
      this.cascadeOpened.emit(false);
    }
    this.setActiveAndSelected();
  }

  onClickCascadeBack(index: number) {
    if (isPlatformBrowser(this.platformId)) {
      this.showTitle = false;
      if (this.isMobileWidth()) {
        this.cascadeMenus.splice(index, 1);
        this.breadcrumbsName.splice(index - 1, 1);
        this.numberOfLinksVisible = this.breadcrumbsName.length - 1
        if (this.cascadeMenus.length > 0) {
          this.cascadeMenus[this.cascadeMenus.length - 1].isVisible = true;
        }
        if (this.isCascadeThemeOpens) {
          this.isCascadeThemeOpens = false;
          this.cascadeThemeOpened.emit(false);
        }
        this.setActiveAndSelected('backClick');
      } else {
        this.cascadeMenus = [];
        let menuHr = this.activRoute.snapshot.queryParamMap.get('menuHierarchy')?.split('_');
        menuHr?.forEach((hierachyInx: any, inx) => {
          if (inx === 0) {
            this.cascadeMenus.push({
              name: '',
              isVisible: true,
              menus: this.menuList[hierachyInx].children
            })
          } else {
            this.cascadeMenus.push({
              name: '',
              isVisible: true,
              menus: this.cascadeMenus[this.cascadeMenus.length - 1].menus[hierachyInx].children
            })
          }
        })
        this.showOverlay = true;
        this.isShowMenubar = true;
        this.isShowCascadebar = true;
        this.cascadeOpened.emit(false);
        this.setActiveAndSelected('backClick');
      }
      if (this.cascadeMenus.length === 0) {
        this.onClickCascadeClose();
      }
    }
  }

  onClickCascadeClose() {
    this.isShowCascadebar = false;
    this.isShowMenubar = true;
  }

  hasTitleBar(index: number) {
    if (isPlatformBrowser(this.platformId)) {
      const windowWidth = window.innerWidth;
      if ((windowWidth < 1023) || (this.showTitle && index === 0)) {
        return true;
      } else {
        return false;
      }
    } else if (this.showTitle && index === 0) {
      return true;
    } else {
      return false
    }
  }

  hasBreadcrumbs() {
    return false;
  }

  displayBreadcrumbs(menu: any) {
    if (menu && menu.name) {
      if (this.breadcrumbsName.length) {
        let breadcrumbsData = this.breadcrumbsName.find(data => data.name === menu.name);
        if (!breadcrumbsData) {
          this.breadcrumbsName.push({
            id: menu.id,
            name: menu.name,
            label: menu.name
          })
          this.numberOfLinksVisible = this.breadcrumbsName.length - 1
        }
      } else {
        this.breadcrumbsName.push({
          id: menu.id,
          name: menu.name,
          label: menu.name
        })
        this.numberOfLinksVisible = this.breadcrumbsName.length - 1
      }
    }
  }

  getBackQueryParam(cascadeMenu: any) {
    let menuArr = cascadeMenu?.menus[0]?.parentId?.split('_');
    let urlChild = this.activRoute.snapshot.children;
    const lastSelected = menuArr?.splice(-1, 1);
    return { menuHierarchy: menuArr?.join('_'), lastSelected: lastSelected, activeMenuHierarchy: this.activeMenuHierarchy, themeId:urlChild[urlChild.length - 1]?.queryParams.themeId? urlChild[urlChild.length - 1]?.queryParams.themeId: null}
  }

  getBackUrl() {
    let urlChild = this.activRoute.snapshot.children;
    let backurl = './' + urlChild[urlChild.length - 1]?.url[0]?.path;
    if (isPlatformBrowser(this.platformId)) {
      backurl = '';
    }
    return backurl;
  }

  ovarlayClickJS() {
    this.showOverlay = false;
    this.isCascadeThemeOpens = false;
    if (this.isShowMenubar) {
      let menuHr = this.activRoute.snapshot.queryParamMap.get('menuHierarchy')?.split('_');
      this.getMenuItemAndShowNavigation(menuHr);
      this.setActiveAndSelected();
    } else {
      this.cascadeMenus.splice(1, this.cascadeMenus.length - 1);
    }
  }

  ngOnDestroy(): void {
    this.subActive = false;
  }
}

